export const CD_AVAILAVILITY_MSG_SEQUENCE = 4;

export const CONTACT_DEALER_SEQUENCES = [3, 4];
